/**
 * Requests a specific landing view for the add account flow. Supplied by referral links
 * through the `r_mode` query parameter, e.g. `mail/addaccount?r_src=WelcomeEmail&r_mode=TypePicker`.
 */
export type AddAccountLaunchMode = 'TypePicker';

export function isAddAccountLaunchMode(value: string | undefined): value is AddAccountLaunchMode {
    return value === 'TypePicker';
}
